/* eslint-disable @typescript-eslint/naming-convention */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import {
  getHistoryQuota,
  GetHubQuota,
  getQuotaDateRange,
  getQuotaFormula,
  putAddManualQuota,
  putQuotaFormula,
} from 'features/Order/services/3plQuota'
import { getOrderLocations } from 'features/Order/services/allOrder'
import { callErrorMsg } from 'helpers/errorMsg'
import { QuotaDailyResponseType, QuotaFormulaPayloadType, QuotaManualAddPayloadType } from './types'

export const SLICE_NAME = '3pl-quota'

export const fetchGetListLocationQuota = createAsyncThunk(
  `${SLICE_NAME}/fetchGetListLocationQuota`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getOrderLocations()

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetHubQuota = createAsyncThunk(
  `${SLICE_NAME}/fetchGetHubQuota`,
  async (payload: { locationId: number; selectedTimestamp: number }, { rejectWithValue }) => {
    try {
      const response = await GetHubQuota(payload)
      return response.data as unknown as QuotaDailyResponseType
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchHistoryQuota = createAsyncThunk(
  `${SLICE_NAME}/fetchHistoryQuota`,
  async (
    params: { 'pagination.limit': number; 'pagination.offset': number },
    { rejectWithValue },
  ) => {
    try {
      const response = await getHistoryQuota(params)

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchTimeframeFormula = createAsyncThunk(
  `${SLICE_NAME}/fetchTimeframeFormula`,
  async (params: { location_id: number }, { rejectWithValue }) => {
    try {
      const response = await getQuotaDateRange(params.location_id)
      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchFormulaData = createAsyncThunk(
  `${SLICE_NAME}/fetchFormulaData`,
  async (
    params: { location_id: number; start_timestamp: number; end_timestamp: number },
    { rejectWithValue },
  ) => {
    try {
      const response = await getQuotaFormula(params)
      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const submitQuotaFormula = createAsyncThunk(
  `${SLICE_NAME}/submitQuotaFormula`,
  async (payload: QuotaFormulaPayloadType, { rejectWithValue }) => {
    try {
      const response = await putQuotaFormula(payload)
      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const submitManualAddQuota = createAsyncThunk(
  `${SLICE_NAME}/submitManualAddQuota`,
  async (payload: QuotaManualAddPayloadType, { rejectWithValue }) => {
    try {
      const response = await putAddManualQuota(payload)
      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
